import { render, staticRenderFns } from "./AnnualLeaveRight.vue?vue&type=template&id=96cb3500&"
import script from "./AnnualLeaveRight.vue?vue&type=script&lang=js&"
export * from "./AnnualLeaveRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports